import { Typography, Grid, Container } from '@material-ui/core';

import Products from './Products/Products';
import Specialities from './Specialities/Specialities';
import Footer from './Footer/Footer';
import useStyles from './styles';

const Content = () => {
	const classes = useStyles();

	return (
		<>
			<div className={classes.spacer} />
			<Container className={classes.titleBackgroundColor}>
				<Typography
					id="products"
					gutterBottom
					className={classes.productsTitle}
					variant="h2"
					align="center"
				>
					Productos
				</Typography>
			</Container>
			<Container>
				<Grid container spacing={5}>
					<Products />
				</Grid>
			</Container>
			<Container className={classes.titleBackgroundColor}>
				<Typography
					id="specialities"
					gutterBottom
					className={classes.specialitiesTitle}
					variant="h2"
					align="center"
				>
					Especialidades
				</Typography>
			</Container>

			<Container>
				<Grid container spacing={5}>
					<Specialities />
				</Grid>
			</Container>
			<Footer id="aboutUs" />
		</>
	);
};

export default Content;
